export function getCurrentLanguage() {
	const lang = document.documentElement.lang;
	if (lang.indexOf('en') > -1) return 'en';
	return 'nl';
}

export function getCookie(name) {
	const value = '; ' + document.cookie;
	const parts = value.split('; ' + name + '=');
	if (parts.length === 2) {
		return parts.pop().split(';').shift();
	}
	return false;
}

export function setCookie(name, value, time) {
	let expires = '';
	if (time != 'session' && time != false) {
		let date = new Date();
		date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toGMTString();
	}
	document.cookie = name + '=' + value + expires + '; SameSite=Strict; path=/';
}

export function changeEmbedWarning() {
	//changes embedded warning if iframe contains the string
	//TODO: retrieving slugs from custom info?
	const slugs = [
		'9292',
		'maps',
		'youtu',
		'vimeo',
		'dailym',
		'soundcl',
		'pippa',
		'spotify',
		'mixcloud',
		'instagram',
		'soundsgood',
		'twit',
		'mailchimp',
		'Mailchimp',
		'MailChimp',
		'facebook',
		'soundcloud',
		'bandcamp',
	];
	const names = [
		'9292',
		'Google Maps',
		'YouTube',
		'Vimeo',
		'Dailymotion',
		'SoundCloud',
		'Pippa',
		'Spotify',
		'MixCloud',
		'Instagram',
		'Soundsgood',
		'Twitter',
		'Mailchimp',
		'Mailchimp',
		'Mailchimp',
		'Facebook',
		'SoundCloud',
		'Bandcamp',
	];
	if (slugs.length > 0) {
		document.querySelectorAll('.js-eagerly-tools-cookie-blocked').forEach((el) => {
			slugs.forEach((slug, index) => {
				if (RegExp(slug).test(el.dataset.embed)) {
					el.querySelectorAll('span').forEach((span) => {
						if (getCurrentLanguage() === 'en') {
							span.innerHTML = 'Your cookie settings are blocking ' + names[index] + '.<br />Please adjust <a href="#" class="">your preferences</a> to enable ' + names[index] + '.';
						} else {
							span.innerHTML = 'Je cookie instellingen blokkeren ' + names[index] + '.<br />Pas <a href="#" class="">je instellingen</a> aan om gebruik te maken van ' + names[index] + '.';
						}
					});
				}
			});
		});
	}
}

export function urldecode(url) {
	return decodeURIComponent(url.replace(/\+/g, ' '));
}

export function enableEmbeds(exceptions) {
	if (!exceptions) exceptions = [];

	// replace element .js-eagerly-tools-cookie-blocked with the value inside its data-embed
	if (exceptions.indexOf('tracking') > -1) {
		const elements = document.querySelectorAll('.js-eagerly-tools-cookie-blocked');
		elements.length > 0 &&
		elements.forEach(function(element) {
			if (element.dataset.embed) {
				// using custom setInnerHTML function because replaceWith / innerHTML doesn't run <script> tags
				setInnerHTML(element, urldecode(element.dataset.embed));
				// move the inner contents one layer up -- ie: delete .js-eagerly-tools-cookie-blocked element
				element.outerHTML = element.innerHTML;
			}
		});
	}
	//show embed warning for embeds that are still blocked
	document.querySelectorAll('.js-eagerly-tools-cookie-blocked').forEach((el) => {
		el.classList.remove('hide');
	});
}

export function enableDataDiv() {
	document.querySelectorAll('.js-cookie-data-div').forEach((el) => {
		const data = el.dataset.div;
		if (data) {
			setInnerHTML(el, urldecode(data));
			el.outerHTML = el.innerHTML;
			el.classList.remove('hide');
		}
	});
}

export function initForm() {
	document.querySelectorAll('.js-cookie-checkbox-group input').forEach((el) =>
		el.addEventListener('change', () => {
			const group = el.closest('.js-cookie-checkbox-group');
			if (el.checked) {
				group.classList.add('checked');
			} else {
				group.classList.remove('checked');
			}
		})
	);
}

/**
 * @param {String} HTML representing a single element
 * @return {Element}
 */
export function htmlToElement(html) {
	let template = document.createElement('template');
	html = html.trim(); // Never return a text node of whitespace as the result
	template.innerHTML = html;
	return template.content;
}

/**
 * Replacement for jQuerys .parents([selector]) function
 * @param {Element} el
 * @param {String} className
 * @returns
 */
export function getParents(el, className) {
	var parents = [];
	var p = el.parentNode;
	while (p !== document) {
		if (p.classList.contains(className)) {
			parents.push(p);
		}
		p = p.parentNode;
	}
	return parents;
}
/**
 * Sets the innerHTML of an element, but will actually run <script>tags</script>
 * @param {Element} elm - The target element.
 * @param {String} html - The html to be set in element.innerHTML
 */
export function setInnerHTML(elm, html) {
	elm.innerHTML = html;
	Array.from(elm.querySelectorAll('script')).forEach( oldScript => {
		const newScript = document.createElement('script');
		Array.from(oldScript.attributes)
			.forEach( attr => newScript.setAttribute(attr.name, attr.value) );
		newScript.appendChild(document.createTextNode(oldScript.innerHTML));
		oldScript.parentNode.replaceChild(newScript, oldScript);
	});
}

/**
 * Replacement for jQuerys .outerHeight(bool) function
 * Including padding, border, scrollbar and optionally margin
 * @param {Element|Element[]} el
 * @param {Boolean} includeMargin
 * @returns
 */
export function getOuterHeight(el, includeMargin) {
	var totalHeight = 0;
	if (el.length > 0) {
		// Multiple elements, like from getElementsByClassName
		for (var i = 0; i < el.length; i++) {
			totalHeight += getOuterHeight(el[i], includeMargin);
		}
	} else {
		// Single element, like from getElementById
		if (el.offsetHeight) {
			totalHeight += el.offsetHeight;
			if (includeMargin) {
				var style = getComputedStyle(el);
				totalHeight += parseInt(style.marginTop) + parseInt(style.marginBottom);
			}
		}
	}

	return totalHeight;
}

/**
 * Replacement for jQuerys .height() function
 * NOT including padding, border, scrollbar or margin
 * @param {Element} el
 * @returns
 */
export function getHeight(el) {
	const computedStyle = getComputedStyle(el);
	return el.clientHeight - parseFloat(computedStyle.paddingTop) - parseFloat(computedStyle.paddingBottom);
}

/**
 * Replacement for jQuerys .next([selector]) function
 * @param {Element} el
 * @param {String} className
 * @returns
 */
export function nextByClass(el, className) {
	while ((el = el.nextSibling)) {
		if (el.classList && el.classList.contains(className)) {
			return el;
		}
	}
	return null;
}
